import { styled } from "@mui/material/styles";
import { NumericTextField } from "../../NumericTextField/NumericTextField";

export const DateOfBirthContainer = styled("div")(({ theme }) => ({
    display: "flex",
    width: theme.space._1300,
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.space._500,
    alignSelf: "stretch",

    "@media (max-width: 600px)": {
        width: "100%"
    }
}));

export const FieldsContainer = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "flex-start",
    gap: theme.space._400,
    alignSelf: "stretch",
}));

export const DateTextField = styled(NumericTextField)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.space._200,
    flex: "1 0 0"
}));